import { ResponsiveLine } from "@nivo/line";

//add your data type when implement
const Chart1 = ({ data }: any) => {
  return (
    <>
      <ResponsiveLine
        data={data}
        defs={[
          {
            colors: [
              {
                color: "inherit",
                offset: 0,
              },
              {
                color: "inherit",
                offset: 100,
                opacity: 0,
              },
            ],
            id: "gradientA",
            type: "linearGradient",
            background: "inherit",
          },
        ]}
        enableArea
        enableSlices="x"
        enableTouchCrosshair
        fill={[
          {
            id: "gradientA",
            match: "*",
          },
        ]}
        margin={{
          bottom: 60,
          left: 70,
          right: 20,
          top: 20,
        }}
        yScale={{
          stacked: true,
          type: "linear",
        }}
        pointBorderWidth={2}
        pointColor="#eeeef9"
        // //pointColor="white"
        pointSize={12}
        areaOpacity={0.1}
        xScale={{ type: "point" }}
        yFormat=" >-$d"
        curve="linear"
        //curve="monotoneX"
        axisTop={null}
        axisRight={null}
        axisBottom={{
          tickSize: 5,
          tickPadding: 5,
          tickRotation: 0,
          legend: "Months", // X axis name
          legendOffset: 36,
          legendPosition: "middle",
        }}
        axisLeft={{
          tickSize: 5,
          tickPadding: 5,
          tickRotation: 0,
          legend: "value",
          legendOffset: -40,
          legendPosition: "middle",
          format: (v) => `$${v}`,
        }}
        enableGridX={false} // enable or disable grid x
        enableGridY={false} // enable or disable grid y
        colors={(d) => d.color} // inherit color from data array
        lineWidth={3}
        pointBorderColor={{
          from: "serieColor",
        }}
        pointLabelYOffset={-12}
        useMesh={true}
        gridYValues={[0, 100, 200, 300, 400]}
        theme={{
          axis: {
            ticks: {
              text: {
                fill: "#7E7988",
              },
            },
            domain: {
              line: {
                stroke: "#e0e0e0",
                strokeWidth: 1,
              },
            },
          },
          grid: {
            line: {
              stroke: "#F3F3F4",
              strokeWidth: 1,
            },
          },
        }}
      />
    </>
  );
};

export default Chart1;
